import React, { useEffect } from "react";
import $ from "jquery";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

export default function GalleryMini({imageSrcList}) {
  useEffect(() => {
    $(".image-popup").magnificPopup({
      type: "image",
      callbacks: {
        beforeOpen: function () {
          this.st.image.markup = this.st.image.markup.replace(
            "mfp-figure",
            "mfp-figure animated zoomInDown"
          );
        },
      },
      gallery: {
        enabled: true,
      },
    });
  }, []);
  return (
    <div className="row">
      <OwlCarousel
        className="rs-carousel owl-carousel"
        loop={true}
        items={3}
        margin={30}
        autoplay={true}
        autoplayHoverPause={true}
        autoplayTimeout={5000}
        smartSpeed={800}
        dots={true}
        nav={false}
        navSpeed={false}
        center={false}
        navText={[
          "<i class='flaticon-left-arrow'></i>",
          "<i class='flaticon-right-arrow'></i>",
        ]}
        responsive={{
          0: {
            items: 1,
            nav: false,
            dots: true,
            center: false,
          },
          768: {
            items: 2,
            nav: false,
            dots: true,
            center: false,
          },
          992: {
            items: 2,
            nav: false,
            dots: true,
            center: false,
          },
          1200: {
            items: 3,
            nav: false,
            dots: true,
            center: false,
          },
        }}
      >
        {imageSrcList.map((img, index) => (
          <div className="" key={`${img}-${index}`}>
            <div className="gallery-item">
              <div className="gallery-icon">
                <a className="image-popup" href={img}>
                  <img src={img} alt="" />
                </a>
              </div>
            </div>
          </div>
        ))}
      </OwlCarousel>
    </div>
  );
}
